<template>
  <div class="notes">
    <image-toolbox :selectedNum="selectedNum" :selectedType="selectedType" v-on:closeSelected="closeSelected" v-on:selectedAll="selectedAll" v-on:cancelSelectedAll="cancelSelectedAll" :selectedImages="selectedImages" :loadedAllImageNum="notes.length"></image-toolbox>
    <div class="view-content notes-view-content">
      <div class="fixed-line clearfix">
        <div class="fixed-left">
          <span class="go-back" @click="goBack">{{$t('list.back')}}</span>
          <span class="name">{{notebookName}}</span>
          <span class="checkbox" :class="{'selected': selectedNum === notes.length}" v-if="notes.length !== 0" @click="selectedAllFn"></span>
        </div>
        <div class="total-item">{{$t('list.total')}} {{total}} {{$t('list.items')}}</div>
      </div>
      <div class="notes-item-wrap clearfix">
        <div class="view-item notes-item-file" :class="{'selected': note.selected}" v-for="(note, index) in notes" :key="index">
          <div class="img-wrap">
            <img v-lazy="note.smallUrl" alt="" @click="showImage(index)">
            <div class="checkbox" @click="selectedFn(index)"></div>
          </div>
          <div class="page-num">{{note.pageNum}}</div>
        </div>
        <div class="no-file" v-if="showNoFile">
          <div class="no-file-main">
            <img src="../../assets/images/no_file.png" alt="">
            <div>{{$t('list.noFile')}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="data-loading" :class="{'show': dataLoading}">
      <div class="container">
        <loading :loading="true"></loading>
        <span class="data-loading-text">{{$t('list.loading')}}</span>
      </div>
    </div>
    <player :images="swiperImages" :show="playerShow" :allIndex="playerStartIndex" @closeButtonClick="closeImagePlayer" v-on:reloadPlayerData="resetPlayerData(arguments[0])" ref="player"></player>
    <processing :processing="processing"></processing>
  </div>
</template>
<script>
import * as Config from 'common/script/config'
import HttpClient from 'common/script/http'
import Notes from 'common/model/Notes'
import ImageToolbox from './ImageToolbox'
import Loading from '../Loading'
import Player from './Player'
import Processing from './Processing'
export default {
  name: 'notes',
  components: {ImageToolbox, Loading, Player, Processing},
  data () {
    return {
      notebookName: '',
      total: 0,
      selectedNum: 0,
      notes: [],
      lastPageNum: '',
      dataLoading: false, // 数据是否在加载
      hasGetAllData: false, // 是否获取到了全部的数据
      playerShow: false,
      swiperImages: [],
      showIndex: 0,
      playerStartIndex: 0,
      allImages: [],
      swiperIndex: 0,
      processing: true,
      showNoFile: false,
      selectedType: 0
    }
  },
  created () {
    this.notebookName = this.$route.query.name
    this.total = this.notes.length
    this.allImages = this.notes
    var obj = this
    setTimeout(function () {
      obj.requestNotesList()
      obj.requetNotesNum()
    }, 100)
  },
  computed: {
    player () {
      return this.$refs.player
    },
    selectedImages () {
      var selectedImages = []
      for (var i = 0; i < this.notes.length; i++) {
        if (this.notes[i].selected) {
          selectedImages.push(this.notes[i])
        }
      }
      return selectedImages
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll: function (event) {
      var t = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
      // 如果页面滑到了最低端，加载更多数据
      if (t >= document.body.scrollHeight - window.screen.height - 5) {
        this.loadingAfterNotesList()
      }
    },
    requestNotesList: function () {
      HttpClient.getData(Config.APP_HOST + '/v1/book/getPageByNoteId/50?u_id=' + Config.cookieGet(Config.COOKIE_KEY.U_ID) + '&noteId=' + this.$route.query.id, this).then((response) => {
        if (response.code === Config.R_CODE.SUCCESS) {
          this.processing = false
          this.assembleImageList(response.body)
          if (this.notes.length <= 0) {
            this.showNoFile = true
          }
        }
      })
    },
    loadingAfterNotesList: function () {
      if (this.dataLoading || this.hasGetAllData) return
      if (this.notes.length > 0) {
        this.dataLoading = true
        HttpClient.getData(Config.APP_HOST + '/v1/book/getPageByNoteId/50?u_id=' + Config.cookieGet(Config.COOKIE_KEY.U_ID) + '&noteId=' + this.$route.query.id + '&pageNum=' + this.lastPageNum, this).then((response) => {
          if (response.code === Config.R_CODE.SUCCESS) {
            this.dataLoading = false
            if (response.body.length === 0) {
              this.hasGetAllData = true
              this.$toasted.show(this.$t('list.loaded'), {
                position: 'bottom-center'
              })
              return
            }
            this.assembleImageList(response.body)
          }
        })
      }
    },
    assembleImageList: function (respNotesList) {
      for (var i = 0; i < respNotesList.length; i++) {
        var n = respNotesList[i]
        var note = new Notes()
        note.loadData(n)
        for (var k = 0; k < this.notes.length; k++) {
          if (note.id === this.notes[k].id) {
            return
          }
        }
        this.notes.push(note)
        this.lastPageNum = this.notes[this.notes.length - 1].pageNum
        // console.log(this.notes)
      }
    },
    requetNotesNum: function () {
      HttpClient.getData(Config.APP_HOST + '/v1/book/getPageCountByNoteId?u_id=' + Config.cookieGet(Config.COOKIE_KEY.U_ID) + '&noteId=' + this.$route.query.id, this).then((response) => {
        if (response.code === Config.R_CODE.SUCCESS) {
          this.total = response.body
        }
      })
    },
    // 之前的
    resetPlayerData: function (playerIndex) {
      var showIndex = this.playerStartIndex + playerIndex
      if (showIndex === this.allImages.length - 2) {
        this.player.cancelReload()
        return
      }
      this.setImagePlayerData(showIndex)
    },
    setImagePlayerData: function (showIndex) {
      // 获取图片预览详情页的数据
      var playCounts = 7
      this.playerStartIndex = showIndex - playCounts
      this.swiperIndex = showIndex - this.playerStartIndex
      if (this.playerStartIndex < 0) {
        this.swiperIndex = this.swiperIndex + this.playerStartIndex
        this.playerStartIndex = 0
      }
      this.swiperImages = this.allImages.slice(this.playerStartIndex, this.playerStartIndex + playCounts * 2 + 1)
      this.player.showImage(this.swiperIndex)
    },
    closeImagePlayer: function () {
      this.playerShow = false
    },
    showImage: function (index) {
      if (this.selectedNum > 0) {
        this.selectedFn(index)
        return
      }
      this.playerShow = true
      this.showIndex = index
      this.setImagePlayerData(this.showIndex)
    },
    selectedAllFn: function () {
      if (this.selectedNum === this.notes.length) {
        this.closeSelected()
      } else {
        this.selectedAll()
      }
    },
    cancelSelectedAll: function () {
      this.closeSelected()
    },
    selectedAll: function () {
      for (var i = 0; i < this.notes.length; i++) {
        this.notes[i].selected = true
      }
      this.selectedNum = this.notes.length
    },
    closeSelected: function () {
      for (var i = 0; i < this.notes.length; i++) {
        this.notes[i].selected = false
      }
      this.selectedNum = 0
    },
    selectedFn: function (index) {
      this.notes[index].selected = !this.notes[index].selected
      if (this.notes[index].selected) {
        this.selectedNum += 1
      } else {
        this.selectedNum -= 1
      }
    },
    goBack: function () {
      this.$router.push('/notebook/notebook/books')
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.view-content
  &.notes-view-content
    padding 90px 0px 80px 0px
    &:hover
      .fixed-line
        .checkbox
          display inline-block
    .fixed-line
      .go-back
        cursor pointer
      .name
        margin 0 13px
      .checkbox
        position static
        vertical-align middle
        &.selected
          display inline-block
          background-image url('../../assets/images/checkbox_click.png')
    .notes-item-wrap
      padding 30px 31px
      box-sizing border-box
      .notes-item-file
        width 20%
        height 270px
        margin 0
        .img-wrap
          width 166px
          height 240px
          max-width 166px
          max-height 240px
          position absolute
          top 0
          left 50%
          margin-left -83px
          cursor pointer
          transition all .3s ease
          background-color #fff
          img
            width 100%
            height 100%
            max-width 100%
            max-height 100%
          .checkbox
            right 10px
            bottom 10px
          &:hover
            top -8px
            .checkbox
              display block
        .page-num
          position absolute
          top 240px
          font-size 12px
          color #999
          padding 6px 0
          box-sizing border-box
        &.selected
          .img-wrap
            img
              opacity 0.5
            .checkbox
              display block
              background-image url('../../assets/images/checkbox_click.png')
</style>



// WEBPACK FOOTER //
// src/components/Notebook/Notes.vue